import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"
import actions from "./actions"
import mutations from "./mutations"
import getters from "./getters"
import { CouponType } from "@reef-os/utils/enums/couponType"

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
	storage: window.localStorage,
	restoreState: (key, storage) => {
		const value = storage.getItem(key)
		if (typeof value === "string") {
			const state = JSON.parse(value || "{}")
			//Migration code to remove currentItem when restoring
			if (state && state.currentItem && state.currentItem.id) {
				state.currentItem = {}
				state.suggestedItemSelected = {}
			}

			//Migration code for new charge card cart model
			state.cart.forEach((item) => {
				if (item.count) {
					item.quantity = item.count
					delete item.count
				}
			})

			//migration code for new firstname lastname
			if (
				state.user &&
				state.user.username &&
				state.user.username.length > 0 &&
				(!state.user.firstname || state.user.firstname.length == 0)
			) {
				let names = state.user.username.split(" ")
				state.user.firstname =
					names && names[0] != undefined ? names[0] : names
				state.user.lastname =
					names && names[1] != undefined ? names[1] : ""
			}

			//Migration code for table should be a string
			if (state.table != undefined && state.table == 0) {
				state.table = "0"
			}

			return state
		} else {
			return value || {}
		}
	},
	reducer: (state) => {
		const storedUser = {}
		for (let prop in state.user) {
			if (prop == "paymentMethods") {
				storedUser.paymentMethods = []
			} else {
				storedUser[prop] = state.user[prop]
				storedUser[prop] = state.user[prop]
			}
		}
		return {
			business: state.business,
			menu: state.menu,
			menuSchedules: state.menuSchedules,
			deliverySlotTypes: state.deliverySlotTypes,
			restaurants: state.restaurants,
			brands: state.brands,
			currentItem: {},
			suggestedItemSelected: {},
			cart: state.cart,
			is_accessible_pickup: null,
			showModal: false,
			deliveryMode: state.deliveryMode,
			businessDropoffLocationId: state.businessDropoffLocationId,
			tipPer: state.tipPer,
			tipCustom: state.tipCustom,
			user: storedUser,
			address: state.address,
			deliveryDate: state.deliveryDate,
			table: state.table,
			purchase: state.purchase,
			orderID: state.orderID,
			orderStatus: state.orderStatus,
			receipt: state.receipt,
			deliveryStatus: state.deliveryStatus,
			delivery: state.delivery,
			deliveryStatusId: state.deliveryStatusId,
			deliveredDate: state.deliveredDate,
			discount: state.discount,
			coupon: state.coupon,
			charge_key: state.charge_key,
			backup_mode: state.backup_mode,
			paymentMethod: state.paymentMethod,
			categories: state.categories,
			businessEvents: state.businessEvents,
			lastCartUpdate: state.lastCartUpdate,
			showVouchers: state.showVouchers
		}
	}
})

export const store = new Vuex.Store({
	state: {
		business: {},
		menu: [],
		menuSchedules: {},
		restaurants: {},
		brands: [],
		loading: false,
		loadingMenu: false,
		currentItem: {},
		suggestedItemSelected: {},
		cart: [],
		deliveryMode: null,
		businessDropoffLocationId: null,
		tipPer: null,
		tipCustom: 0,
		user: {
			accessToken: "",
			refreshToken: "",
			username: "",
			firstname: "",
			lastname: "",
			phone: "",
			email: "",
			isVerified: 0,
			isActive: 0,
			id: 0,
			smsOptIn: 0,
			businessId: 0,
			apartmentNumber: "",
			picture: "",
			paymentMethods: [],
			coupons: [],
			campaigns: [],
			notifications: []
		},
		address: {
			address: "",
			address2: "",
			city: "",
			state: "",
			zip: ""
		},
		deliveryDate: null,
		table: "0",
		purchase: false,
		orderID: "",
		orderStatus: {},
		receipt: {},
		orders: [],
		deliveryStatus: {},
		deliveryStatusId: 0,
		deliveredDate: null,
		delivery: {},
		discount: 0,
		coupon: {
			code: "",
			id: 0,
			couponType: CouponType.DEFAULT,
			token: null
		},
		charge_key: "",
		backup_mode: false,
		paymentMethod: null,
		categories: {},
		businessEvents: [],
		temporaryFlag: {
			displayedUpcomingModal: false,
			displayedActivationModal: false,
			isGuestCheckoutActive: false
		},
		lastCartUpdate: null,
		showVouchers: false,
		sessionOrderLoaded: false,
		isKioskFlow: false
	},
	plugins: [vuexLocal.plugin],
	getters,
	mutations,
	actions
})
